import { isGridCell } from '@material-ui/data-grid';
import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class VizsgaFeladatTableDto extends IdentifiableDto {
	/**
	 * @module VizsgaFeladatTableDto
	 */
	constructor() {
		super();
		/** @type {string} */
		this.kod = null;
		/** @type {number} */
		this.kerdesSorszam = null;
		/** @type {number} */
		this.kerdesAlsorszam = null;
		/** @type {number} */
		this.kerdesSubsorszam = null;
		/** @type {number} */
		this.fosorszam = null;
		/** @type {number} */
		this.alsorszam = null;
		/** @type {number} */
		this.torolt = null;
		/** @type {string} */
		this.kerdesLeirasPlaintext = null;
	}

	/**
	 * @typedef {Object} _VizsgaFeladatTableDtoProps
	 * @property {string} kod
	 * @property {number} kerdesSorszam
	 * @property {number} kerdesAlsorszam
	 * @property {number} kerdesSubsorszam
	 * @property {number} fosorszam
	 * @property {number} alsorszam
	 * @property {number} torolt
	 * @property {string} kerdesLeirasPlaintext
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _VizsgaFeladatTableDtoProps} VizsgaFeladatTableDtoProps
	 */
	/**
	 *
	 * @param {VizsgaFeladatTableDtoProps} props
	 * @returns {VizsgaFeladatTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.kod = props.kod;
		this.kerdesSorszam = props.kerdesSorszam;
		this.kerdesAlsorszam = props.kerdesAlsorszam;
		this.kerdesSubsorszam = props.kerdesSubsorszam;
		this.fosorszam = props.fosorszam;
		this.alsorszam = props.alsorszam;
		this.torolt = props.torolt;
		this.kerdesLeirasPlaintext = props.kerdesLeirasPlaintext;
		return this;
	}

	getAsString(key) {
		if (key === 'genKerdesSorszam') {
			return `${this.kod} - ${this.kerdesSorszam}.${this.kerdesAlsorszam}.${this.kerdesSubsorszam}`;
		}
		if (key === 'genSorszam') {
			return `${this.fosorszam}.${this.alsorszam}`;
		}
		return super.getAsString(key);
	}
}

export default VizsgaFeladatTableDto;
